import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';

import { confirm } from '../../utils/confirmationDialogHelper';
import { warn } from '../../utils/warnDialogHelper';
import { cancelBooking, setRescheduleObject } from '../../actions/reservationActions';
import { selectDayAndService } from '../../actions/filterActions';

import AddToCalendarDropdown from '../AddToCalendarDropdown/AddToCalendarDropdown';

import './BookingListItemActions.css';

class BookingListItemActions extends Component {
  handleRescheduleBooking = (teacher, event) => {
    // prevent navigation to # anchor with preventDefault
    event.preventDefault();

    const { serviceId } = this.props.booking;
    const selectedDay = this.props.startDateTime.clone().startOf('day');

    // set the rescheduleObject
    this.props.setRescheduleObject(this.props.booking);

    // set the day for the DateBar filter and ServiceId
    this.props.selectDayAndService(selectedDay, { id: serviceId });

    // redirect to teacher booking page
    browserHistory.push(`/schedule-lesson/${teacher.slug}`);
  }

  handleCancelBooking = (event) => {
    // prevent navigation to # anchor with preventDefault
    event.preventDefault();
    // startDateTime is a clone of moment object
    const { startDateTime } = this.props;
    const latestCancellableTime = moment().add(6, 'hours');
    if (startDateTime.isSameOrBefore(latestCancellableTime)) {
      warn('You cannot cancel the lesson 6 hours before the lesson starts.');
    } else {
      confirm('Are you sure you want to cancel this appointment?', result => {
      // if the user selects OK, delete this booking
        if (result === true) {
          this.props.cancelBooking(this.props.booking.id);
        }
      });
    }
  }

  render() {
    const {
      startDateTime, endDateTime, teacher, serviceName
    } = this.props;

    const calData = {
      booking: this.props.booking,
      startDateTime: startDateTime.clone(),
      endDateTime: endDateTime.clone(),
      serviceName,
      teacherName: teacher.name,
      teacherSkypeUsername: teacher.skypeName,
      studentSkypeUsername: this.props.user.skypeName
    };

    return (
      <div className="BookingListItemActions">
        <div className="booking-actions d-flex flex-column flex-sm-row align-items-center justify-content-center">
          {// don't display reschedule link if the teacher obj is empty
          _.isEmpty(teacher) ? (
            ''
          ) : (
            <Fragment>
              <a className="skypeID" href={`skype:${teacher.skypeName}?chat`}>
                <img
                  style={{
                    width: 18, height: 18, marginTop: -4, marginRight: 8
                  }}
                  src="/assets/skype.png"
                  alt="skype"
                />
                <span>Skype ID: {teacher.skypeName}</span>
              </a>
              <a href="#" onClick={this.handleRescheduleBooking.bind(this, teacher)} data-qa-id="reschedule-lesson-link">
                Reschedule
              </a>
            </Fragment>
          )
        }

          <a href="#" onClick={this.handleCancelBooking} data-qa-id="cancel-lesson-link">
            Cancel
          </a>

          <AddToCalendarDropdown calData={calData} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile
  };
}

export default connect(
  mapStateToProps,
  {
    cancelBooking,
    setRescheduleObject,
    selectDayAndService
  }
)(BookingListItemActions);



// WEBPACK FOOTER //
// ./src/components/BookingListItemActions/BookingListItemActions.js